// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__SM3C2","rotate":"loader_rotate__Qjfck"};